export default "__VITE_ASSET__Bw_W8mRl__"